import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const KwHpConverterGuidePage = () => <DataDrivenGuidePage slug="guide-kw-hp-calculator" />;

export default KwHpConverterGuidePage;
